import { computed } from 'vue'

import type { Ref } from 'vue'

import { useTracksLiveKit } from '@hooks/classroom/tracks-live-kit.hook'
import { useRoomLiveKit } from '@hooks/classroom/room-live-kit.hook'
import { usePip } from '@hooks/pip/index.hook'

interface ClassroomPipReturn {
  isSupported: boolean
  isActive: Ref<boolean>
  toggle: () => Promise<void>
}

export const useClassroomPip = (): ClassroomPipReturn => {
  const tracks = useTracksLiveKit()
  const { remoteIdentities } = useRoomLiveKit()

  const tutorTrack = computed<MediaStreamTrack | null>(() =>
    tracks.isRemoteCameraMuted.value ? null : (tracks.remoteCameraTrack.value?.mediaStreamTrack ?? null),
  )
  const studentTrack = computed<MediaStreamTrack | null>(() =>
    tracks.isCameraEnabled.value ? (tracks.localCameraTrack.value?.mediaStreamTrack ?? null) : null,
  )
  const tutorPresent = computed<boolean>(() => remoteIdentities.value.length > 0)

  return usePip({
    tutorTrack,
    studentTrack,
    tutorPresent,
    micEnabled: tracks.isMicEnabled,
    camEnabled: tracks.isCameraEnabled,
    onToggleMic: () => { void tracks.toggleMic() },
    onToggleCam: () => { void tracks.toggleCamera() },
  })
}
